import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router'
import dataV from '@jiaminghi/data-view'
Vue.use(dataV)
Vue.use(ElementUI, {
  size: 'size' // set element-ui default size
})
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
